import { X } from "lucide-react";
import { Button } from "./button";
import { __ } from "@/i18n";
import AccessiYesNoticeLogo from "@/icons/accessiyes-notice-logo";
import { useReviewBannerVisibility } from "@/hooks/useReviewBannerVisibility";

const ReviewBanner = () => {
  const { isVisible, hidePermanently, hideTemporarily } = useReviewBannerVisibility();

  if (!isVisible) return null;

  const reviewUrl = window.cyA11yGlobals.reviewBanner.reviewUrl;

  const handleReviewNow = async () => {
    window.open(reviewUrl, "_blank", "noopener,noreferrer");
    await hidePermanently();
  };

  return (
    <div className="cy:max-w-7xl cy:mx-auto cy:px-4 cy:sm:px-6 cy:lg:px-8 cy:pt-8">
      <div className="cy:relative cy:rounded-[5px] cy:border cy:border-[#d7e1f2] cy:bg-white cy:px-4 cy:py-4 cy:shadow-sm">
        <button
          onClick={hideTemporarily}
          className="cy:absolute cy:right-4 cy:top-4 cy:flex cy:h-8 cy:w-8 cy:items-center cy:justify-center cy:rounded-full cy:text-[#7e7e7e] cy:transition-colors hover:cy:bg-black/5 hover:cy:text-[#555d66]"
          aria-label={__( 'Dismiss review banner', 'accessibility-widget' )}
          type="button"
        >
          <X size={18} />
        </button>

        <div className="cy:max-w-7xl cy:gap-2">
          <AccessiYesNoticeLogo
            role="img"
            aria-label="AccessiYes by CookieYes"
            className="cy:mb-3 cy:h-7 cy:w-auto"
          />

          <p className="cy:mb-3 cy:text-[14px] cy:font-[400] cy:leading-5 cy:text-[#000000] cy:pb-3 cy:pt-1">
            {__( 'Hey, we at', 'accessibility-widget' )} <strong>AccessiYes</strong> {__( 'would like to thank you for using our plugin. We would really appreciate if you could take a moment to drop a quick review that will inspire us to keep going.', 'accessibility-widget' )}
          </p>
            <div className="cy:flex cy:flex-wrap cy:gap-3">
            <Button
              type="button"
              onClick={handleReviewNow}
              className="cy:h-8 cy:min-w-[94px] cy:rounded-[3px] cy:bg-[#1578F7] cy:px-[14px] cy:py-2 cy:text-[14px]! cy:font-bold! cy:text-white hover:cy:bg-[#1558c7]"
            >
              {__( 'Review now', 'accessibility-widget' )}
            </Button>
            <Button
              type="button"
              variant="outline"
              onClick={hidePermanently}
              className="cy:h-8 cy:min-w-[124px] cy:rounded-[3px] cy:border-[#baafaf] cy:px-[14px] cy:py-2 cy:text-[14px]! cy:font-bold! cy:text-[#756f6f] cy:opacity-50 hover:cy:bg-[#f6f7f7]"
            >
              {__( 'Never show again', 'accessibility-widget' )}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReviewBanner;
